import React, { Component } from 'react'
import AWSAPI from '../../../common/AWSAPI'
import Window from '../../../common/Window'
import Loading from '../../../common/component/Loading'
import Config from '../../../Config'

class SurveyAnswer extends Component {
  constructor (props) {
    super(props)
    const initialState = this.getInitialState()
    this.state = initialState
    this.apiUrl = Config.companyUserApiUrl.surveyAnswer
    this.userRole = 'companyUser'
  }
  getInitialState () {
    return {
      isLoaded: false,
      surveyMainItems: [],
      surveyBigQuestionItems: [],
      surveyMediumQuestionItems: [],
      surveySmallQuestionItems: [],
      surveyChoiseItems: [],
      answerId: null,
      answerItems: [],
      choiceInputs: {},
      choiceInputs2: {},
      inputs: {},
      errorFields: {},
    }
  }
  componentDidMount() {
    const dt = new Date();
    const currentYear = dt.getFullYear();
    const fiscalYear = dt.getMonth() < 3 ? currentYear - 1 : currentYear;
    this.loadServey(fiscalYear);
  }

  componentDidUpdate(prevProps, prevState) {
    // surveyMediumQuestionItems が更新された場合のみ処理を実行
    if (prevState.surveyMediumQuestionItems !== this.state.surveyMediumQuestionItems && this.state.surveyMediumQuestionItems.length > 0) {
      this.state.surveyMediumQuestionItems.forEach((mediumItem) => {
        const linkedSmallQuestions = this.state.surveySmallQuestionItems.filter(
          (smallItem) => smallItem.medium_question_id == mediumItem.id
        );
        let keyIndex = 0;
        let key = '';
        linkedSmallQuestions.forEach((smallItem) => {
          if(key == `${mediumItem.id}-${smallItem.setsumon_text}`) {
            keyIndex++
          } else {
            keyIndex = 1
            key = `${mediumItem.id}-${smallItem.setsumon_text}`
          }
          const answerValue = this.state.answerItems[smallItem.id];
          if (answerValue && smallItem.summary_flg == 1) {
            const numericValue = parseInt(answerValue, 10) || 0; // value を数値に変換
            this.calculateSum(key, mediumItem.id, keyIndex, numericValue);
          }
        });
      });
    }
  }
  loadServey(year) {
    const onSuccess = (res) => {
      // APIから取得したデータをstateに反映
      const surveyQuestionData = res.body.data
      this.setState({
        isLoaded: true,
        surveyMainItems: surveyQuestionData && surveyQuestionData.surveyMainItems && surveyQuestionData.surveyMainItems.length > 0 
          ? surveyQuestionData.surveyMainItems[0] : [],
        surveyBigQuestionItems: surveyQuestionData && surveyQuestionData.surveyBigQuestionItems 
          ? surveyQuestionData.surveyBigQuestionItems : [],
        surveyMediumQuestionItems: surveyQuestionData && surveyQuestionData.surveyMediumQuestionItems 
          ? surveyQuestionData.surveyMediumQuestionItems : [],
        surveySmallQuestionItems: surveyQuestionData && surveyQuestionData.surveySmallQuestionItems 
          ? surveyQuestionData.surveySmallQuestionItems : [],
        surveyChoiseItems: surveyQuestionData && surveyQuestionData.surveyChoiseItems 
          ? surveyQuestionData.surveyChoiseItems : [],
        answerId: surveyQuestionData && surveyQuestionData.surveyAnswerItems && surveyQuestionData.surveyAnswerItems.length > 0 
          ? surveyQuestionData.surveyAnswerItems[0].id : null,
        answerItems: surveyQuestionData && surveyQuestionData.surveyAnswerItems && surveyQuestionData.surveyAnswerItems.length > 0 
          ? JSON.parse(surveyQuestionData.surveyAnswerItems[0].answerData) : [],
      });
    }
    const params = {
      command: 'getQuestion',
      surveyValue: { year: year },
    }
    AWSAPI.apiPost(this.userRole, this.apiUrl, params, onSuccess)
  }
  saveServey () {
    const servey = this.state
    const id = servey.answerId || null

    let hasError = false;
    let errorFields = {};

    // バリデーション
    if (servey.answerItems[1] === '' || servey.answerItems[1] === undefined) {
      Window.alert('会社名は必須です。');
      errorFields[1] = true;
      hasError = true;
    }
    if (servey.answerItems[2] === '' || servey.answerItems[2] === undefined) {
      Window.alert('会社所在地は必須です。');
      errorFields[2] = true;
      hasError = true;
    }
    if (servey.answerItems[3] === '' || servey.answerItems[3] === undefined) {
      Window.alert('会社所在地は必須です。');
      errorFields[3] = true;
      hasError = true;
    }

    // 電話番号バリデーション
    const phoneRegex = /^(0\d{1,4}-\d{1,4}-\d{4}|0\d{9,10})$/;
    if (servey.answerItems[4] && !phoneRegex.test(servey.answerItems[4])) {
      Window.alert('電話番号は正しい形式で入力してください。\n（例：090-1234-5678 または 09012345678）');
      errorFields[4] = true;
      hasError = true;
    }
    if (servey.answerItems[5] && !phoneRegex.test(servey.answerItems[5])) {
      Window.alert('FAX番号は正しい形式で入力してください。\n（例：090-1234-5678 または 09012345678）');
      errorFields[5] = true;
      hasError = true;
    }

    // メールアドレスバリデーション
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (servey.answerItems[6] && !emailRegex.test(servey.answerItems[6])) {
      Window.alert('有効なメールアドレスを入力してください。');
      errorFields[6] = true;
      hasError = true;
    }

    // 所属支部名バリデーション
    if (
      servey.answerItems[7] === "1" &&
      (servey.answerItems[8] === '' || servey.answerItems[8] === undefined)
    ) {
      Window.alert('所属支部名を選択してください。');
      errorFields[8] = true;
      hasError = true;
    }

    if (hasError) {
      // エラーがある場合、該当フィールドに赤色の枠を表示
      this.setState({ errorFields });
      return false;
    }

    let updateOrInsert

    if (id) { // 更新
      updateOrInsert = (oldSurveyValue) => {
        const result = {
          id: id,
          surveyMainId: servey.surveyMainItems.id,
          answerData: JSON.stringify(servey.answerItems),
        }
        return result
      }
    } else { // 新規登録
      updateOrInsert = (oldSurveyValue) => {
        const result = {
          id: this.uuid(),
          surveyMainId: servey.surveyMainItems.id,
          answerData: JSON.stringify(servey.answerItems),
        }
        return result
      }
    }
    const surveyValue = updateOrInsert(servey)
    let paramsToSet = [];
    if(id) {
      paramsToSet = {
        command: 'set',
        surveyValue: surveyValue
      }
    } else {
      paramsToSet = {
        command: 'add',
        surveyValue: surveyValue
      }
    }
    const onSuccessToPost = (res) => {
      Window.alert('保存しました', () => {
        this.props.history.push('/company_admin/survey_answer')
        this.setState({ errorFields: {} });
        Window.closeDialog()
      })
    }
    AWSAPI.apiPost(this.userRole, this.apiUrl, paramsToSet, onSuccessToPost)
  }
  onPageMenuClicked (name) {
    const id = this.state.id
    switch (name) {
      case 'back':
        this.props.history.push('/company_admin/')
        break
      default:
        break
    }
  }
  uuid () {
    let uuid = ''
    let i
    let random
    for (i = 0; i < 32; i++) {
      random = Math.random() * 16 | 0

      if (i === 8 || i === 12 || i === 16 || i === 20) {
        uuid += '-'
      }
      uuid += (i === 12 ? 4 : (i === 16 ? ((random & 3) | 8) : random)).toString(16)
    }
    return uuid
  }
  sumChanged = (name, e) => {
    const value = e.target.value.replace(/[^0-9]/g, ""); // 数字以外の文字を削除
    const numericValue = value ? parseInt(value, 10) : 0;

    const { medium: inputKey, small: inputIndex } = e.target.dataset;
    const numericInputIndex = Number(inputIndex);
    if (!inputKey || !inputIndex) {
      console.error("データ属性 'data-medium' または 'data-small' が不足しています:", e.target);
      return;
    }

    this.calculateSum(name, inputKey, numericInputIndex, numericValue);
  }
  calculateSum = (name, inputKey, inputIndex, numericValue) => {
    this.setState((prevState) => {
      const newChoiceInputs = { ...prevState.choiceInputs2 };
      // 初期化: 該当する name が存在しない場合は新しいデータを作成
      if (!newChoiceInputs[name]) {
        newChoiceInputs[name] = { inputs: [], sumByIndex: {}, sum: 0, totalsum: 0 };
      }

      // inputs 内で該当する index を検索
      const existingIndex = newChoiceInputs[name].inputs.findIndex(
        (input) => input.index === inputIndex
      );

      if (existingIndex >= 0) {
        // 既存のインデックスを更新
        newChoiceInputs[name].inputs[existingIndex].value = numericValue;
      } else {
        // 新しいインデックスを追加
        newChoiceInputs[name].inputs.push({ index: inputIndex, value: numericValue });
      }

      // グループごとの sumByIndex を再計算
      const groupedSumByIndex = {};
      Object.keys(newChoiceInputs).forEach((key) => {
        const groupKey = key.split("-")[0]; // 数値部分を抽出
        if (!groupedSumByIndex[groupKey]) {
          groupedSumByIndex[groupKey] = {};
        }

        newChoiceInputs[key].inputs.forEach((input) => {
          if (!groupedSumByIndex[groupKey][input.index]) {
            groupedSumByIndex[groupKey][input.index] = 0;
          }
          groupedSumByIndex[groupKey][input.index] += input.value;
        });
      });

      // 各キーの sumByIndex を更新
      Object.keys(newChoiceInputs).forEach((key) => {
        const groupKey = key.split("-")[0];
        newChoiceInputs[key].sumByIndex = groupedSumByIndex[groupKey];

        // sum を計算（key ごとの inputs の合計）
        newChoiceInputs[key].sum = newChoiceInputs[key].inputs.reduce(
          (total, input) => total + input.value,
          0
        );
      });

      // key の数値部分ごとに sum を合計して totalsum に設定
      const groupedTotalSum = {};
      Object.keys(newChoiceInputs).forEach((key) => {
        const groupKey = key.split("-")[0];
        if (!groupedTotalSum[groupKey]) {
          groupedTotalSum[groupKey] = 0;
        }
        groupedTotalSum[groupKey] += newChoiceInputs[key].sum;
      });

      // 各キーに totalsum を設定
      Object.keys(newChoiceInputs).forEach((key) => {
        const groupKey = key.split("-")[0];
        newChoiceInputs[key].totalsum = groupedTotalSum[groupKey];
      });

      return { choiceInputs2: newChoiceInputs };
    });
  }

  renderSurveyDetail(state, summaryCnt) {
    const survey = state;
    const changed = (path, value) => {
      this.setState((prevState) => {
        const stateCopy = { ...prevState };

        // 深いプロパティを扱うためのユーティリティ
        const keys = Array.isArray(path) ? path : [path];
        let current = stateCopy;

        keys.slice(0, -1).forEach((key) => {
          current[key] = { ...current[key] }; // ネストされたオブジェクトをコピー
          current = current[key];
        });

        current[keys[keys.length - 1]] = value;

        return stateCopy;
      });
    };

    const bigQuestionItems = survey.surveyBigQuestionItems || [];
    const mediumQuestionItems = survey.surveyMediumQuestionItems || [];
    const smallQuestionItems = survey.surveySmallQuestionItems || [];
    const choiseItems = survey.surveyChoiseItems || [];
    const answerItems = survey.answerItems || [];

    let firstType1Set = false;
    let firstType2Set = false;

    const renderTable1 = (bigItem) => {
      let rows = [];
      const linkedMediumQuestions = mediumQuestionItems.filter(
        (mediumItem) => mediumItem.big_question_id == bigItem.id
      );

      if (!firstType1Set) {
        rows.push(
          <tr key={`title-${bigItem.id}`}>
            <td colSpan="4" style={{ fontWeight: 'bold', fontSize: '1.3em' }}>
              １．回答会社連絡先等　以下の項目をご記入ください。
            </td>
          </tr>
        );
        firstType1Set = true;
      }

      let isBigItemDisplayed = false;
      let beforeSetsumonType = 0;
      linkedMediumQuestions.forEach((mediumItem) => {
        const linkedSmallQuestions = smallQuestionItems.filter(
          (smallItem) =>
            smallItem.big_question_id == bigItem.id &&
            smallItem.medium_question_id == mediumItem.id
        );

        linkedSmallQuestions.forEach((smallItem) => {
          const linkedChoises = choiseItems.filter(
            (choiseItem) => choiseItem.choise_type == smallItem.setsumon_type
          );

          let smallItemTitle = null;
          if (beforeSetsumonType == 2 && smallItem.setsumon_type == 0) {
            smallItemTitle = (
              <td style={{ width: '20%', paddingLeft: '45px' }}>
                {smallItem.setsumon_text}
              </td>
            );
          } else if (smallItem.setsumon_type == 2) {
            smallItemTitle = (
              <td style={{ width: '20%', paddingLeft: '45px' }}>
                {smallItem.setsumon_text}
              </td>
            );
          } else {
            smallItemTitle = (
              <td style={{ width: '20%', paddingLeft: '45px' }}>&nbsp;</td>
            );
          }
          beforeSetsumonType = smallItem.setsumon_type;

          const smallItemComment = (
            <td style={{ width: '40%', paddingLeft: '5px' }}>
              {bigItem.setsumon_comment}
            </td>
          );

          let choiceInputs = null;

          if (smallItem.setsumon_type == 1) {
            // ラジオボタンの場合
            choiceInputs = (
              <td colSpan="2">
                {linkedChoises.map((choise, index) => {
                  // 初期値が未設定の場合、最初の選択肢をセット
                  if (!answerItems[smallItem.id] && index === 0) {
                    // 初期値をservey.answerItemsに設定
                    changed(['answerItems', smallItem.id], choise.choise_sort);
                  }

                  return (
                    <label
                      key={`choice-${smallItem.id}-${choise.choise_sort}`}
                      style={{ display: 'inline-flex', alignItems: 'center' }}
                    >
                      <input
                        type="radio"
                        name={`radio-${smallItem.id}`}
                        value={choise.choise_sort}
                        checked={answerItems[smallItem.id] == choise.choise_sort}
                        onChange={(e) =>
                          changed(['answerItems', smallItem.id], e.target.value)
                        }
                      />
                      <span style={{ marginLeft: '5px' }}>{choise.choise_text}</span>
                    </label>
                  );
                })}
              </td>
            );
          } else if (smallItem.setsumon_type == 2 || smallItem.setsumon_type == 3) {
            // セレクトボックスの場合
            choiceInputs = (
              <td colSpan="2">
                <select
                  value={answerItems[smallItem.id] || ''}
                  onChange={(e) =>
                    changed(['answerItems', smallItem.id], e.target.value)
                  }
                  style={{ borderColor: (survey.errorFields && survey.errorFields[smallItem.id]) ? 'red' : 'initial', maxWidth: '150px' }}
                >
                  <option value="">選択してください</option>
                  {linkedChoises.map((choise) => (
                    <option
                      key={`choice-${smallItem.id}-${choise.choise_sort}`}
                      value={choise.choise_sort}
                    >
                      {choise.choise_text}
                    </option>
                  ))}
                </select>
              </td>
            );
          } else {
            // テキストボックスの場合
            choiceInputs = (
              <td colSpan="2">
                <input
                  type="text"
                  style={{ width: '100%', maxWidth: '400px', borderColor: (survey.errorFields && survey.errorFields[smallItem.id]) ? 'red' : 'initial' }}
                  value={answerItems[smallItem.id] || ''}
                  placeholder={smallItem.setsumon_comment}
                  onChange={(e) =>
                    changed(['answerItems', smallItem.id], e.target.value)
                  }
                />
              </td>
            );
          }

          if (!isBigItemDisplayed) {
            rows.push(
              <tr key={`bigItem-${bigItem.id}`}>
                <td colSpan="4" style={{ paddingLeft: '15px', fontWeight: 'bold' }}>
                  {bigItem.setsumon_title}
                </td>
              </tr>
            );
            isBigItemDisplayed = true;
          }

          rows.push(
            <tr key={`smallItem-${smallItem.id}`}>
              {smallItemTitle}
              {choiceInputs}
              {smallItemComment}
            </tr>
          );
        });
      });

      return rows;
    };

    const renderTable2 = (bigItem) => {
      let rows = [];
      const linkedMediumQuestions = mediumQuestionItems.filter(
        (mediumItem) => mediumItem.big_question_id == bigItem.id
      );

      if (!firstType2Set) {
        rows.push(
          <tr key={`title-${bigItem.id}`}>
            <td colSpan="17" style={{ fontWeight: 'bold', fontSize: '1.3em' }}>
              ２．質問事項
            </td>
          </tr>
        );
        firstType2Set = true;
      }

      let isBigItemDisplayed = false;

      linkedMediumQuestions.forEach((mediumItem) => {
        let isMediumItemDisplayed = false;
        const linkedSmallQuestions = smallQuestionItems.filter(
          (smallItem) =>
            smallItem.big_question_id == bigItem.id &&
            smallItem.medium_question_id == mediumItem.id
        );

        if (!isBigItemDisplayed) {
          rows.push(
            <tr key={`bigItem-${bigItem.id}`}>
              <td
                colSpan="17"
                style={{ paddingLeft: "15px", fontWeight: "bold" }}
              >
                {bigItem.setsumon_title}
                {bigItem.setsumon_comment ? bigItem.setsumon_comment.split("※").map((part, index) => (
                    <span key={index} style={{ display: "block", paddingLeft: "15px", fontWeight: "normal" }}>
                      {index > 0 ? "※" + part : part}
                    </span>
                  ))
                : null}
              </td>
            </tr>
          );
          isBigItemDisplayed = true;
        }
        rows.push(
          <tr key={`mediumItem-${mediumItem.id}`}>
            <td colSpan="17" style={{ paddingLeft: "15px", fontWeight: "bold" }}>
              {mediumItem.setsumon_text.split('\\n').map((line, index) => (
                <span key={index}>
                  {line}
                  <br />
                </span>
              ))}
            </td>
          </tr>
        );

        let choiceHeaders = [];
        let choiceInputs2 = {}; // 動的に管理するオブジェクトに変更
        let summaryTableFlg = false;
        let smallIndex = 1; // 初期の smallIndex
        let inputTitle = null;
        let inputText = null;

        linkedSmallQuestions.forEach((smallItem) => {
          const key = `${mediumItem.id}-${smallItem.setsumon_text}`;

          // keyが変わるタイミングでsmallIndexをリセット
          if (!choiceInputs2[key]) {
            smallIndex = 1; // smallIndexをリセット
            choiceInputs2[key] = { inputs: [], sum: 0 }; // 合計値を格納するためのオブジェクトに変更

            // ヘッダー（<th>）を最初に追加する処理
            choiceInputs2[key].inputs.push(
              <th style={{ backgroundColor: "#f1f1f1", textAlign: "center", border: "1px solid", fontWeight: "bold" }} key={`label-${key}`} >
                {smallItem.setsumon_text}
              </th>
            );
          }

          if (smallItem.setsumon_type == 0 && smallItem.summary_flg == 1) {
            summaryTableFlg = true;

            // 集計表ヘッダーの管理
            if (!choiceHeaders.some((header) => header.props.children == smallItem.setsumon_text2)) {
              choiceHeaders.push(
                <th key={`header-${smallItem.id}`} style={{ width: "7%", backgroundColor: "#f1f1f1", border: "1px solid" }}>
                  {smallItem.setsumon_text2}
                </th>
              );
            }

            // 入力フィールドと合計計算
            choiceInputs2[key].inputs.push(
              <td style={{ border: "1px solid" }} key={`input-${smallItem.id}`}>
                <input type="text" data-medium={mediumItem.id} data-small={smallIndex} onInput={(e) => (e.target.value = e.target.value.replace(/[^0-9]/g, ""))}
                  value={answerItems[smallItem.id] || ''}
                  onChange={(e) => {
                    changed(['answerItems', smallItem.id], e.target.value)
                    const newValue = e.target.value.replace(/[^0-9]/g, ""); // 数字以外を削除
                    this.setState((prevState) => ({
                      inputs: {
                        ...prevState.inputs,
                        [smallItem.id]: newValue, // 状態を更新
                      },
                    }));
                    this.sumChanged(key, e); // 合計計算
                  }}
                  style={{ width: "80%", textAlign: "right", appearance: "textfield" }}
                />
              </td>
            );
            smallIndex++; // smallIndexをインクリメント
          } else if(smallItem.setsumon_type == 0 && smallItem.summary_flg == 0) {
            rows.push(
              <div className="subtable-container">
              <table style={{ width: "90%", margin: "10px", borderCollapse: "collapse" }}>
                <tbody>
                <tr key={`input-${smallItem.id}`}>
                  <th style={{ width: "20%", textAlign: "center" }} key={`label-${key}`}>
                    {smallItem.setsumon_text}
                  </th>
                  <td>
                    <textarea className='span10' value={answerItems[smallItem.id] || ''} onChange={(e) => changed(['answerItems', smallItem.id], e.target.value)} />
                  </td>
                </tr>
                </tbody>
              </table>
              </div>
            );
          } else if(smallItem.setsumon_type == 4) {
            const linkedChoises = choiseItems.filter(choiseItem => choiseItem.choise_type == smallItem.setsumon_type);
            rows.push(
              <div className="subtable-container">
              <table style={{ width: "90%", margin: "0 20px", borderCollapse: "collapse" }}>
                <tbody>
                <tr key={`input-${smallItem.id}`}>
                  <td style={{ width: "85%", fontWeight: "bold" }}>
                    {smallItem.setsumon_text}
                  </td>
                  <td rowspan="2">
                    <select value={answerItems[smallItem.id] || ''} onChange={(e) => changed(['answerItems', smallItem.id], e.target.value)} style={{ maxWidth: '150px' }}>
                      <option value="">選択してください</option>
                      {linkedChoises.map((choise, choiceIndex) => (
                        <option key={choiceIndex} value={choise.choise_sort}>
                          {choise.choise_text}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: "0 20px", fontWeight: "bold" }}>
                    {smallItem.setsumon_text2}
                  </td>
                </tr>
                </tbody>
              </table>
              </div>
            );
          } else if(smallItem.setsumon_type == 5) {
            const linkedChoises = choiseItems.filter(choiseItem => choiseItem.choise_type == smallItem.setsumon_type);
            rows.push(
              <div className="subtable-container">
              <table style={{ width: "90%", margin: "0 20px", borderCollapse: "collapse" }}>
                <tbody>
                <tr key={`input-${smallItem.id}`}>
                  <td style={{ width: "20%", fontWeight: "bold" }}>
                    {smallItem.setsumon_text}
                  </td>
                  <td rowspan="2">
                    <select value={answerItems[smallItem.id] || ''} onChange={(e) => changed(['answerItems', smallItem.id], e.target.value)} style={{ maxWidth: '150px' }}>
                      <option value="">選択してください</option>
                      {linkedChoises.map((choise, choiceIndex) => (
                        <option key={choiceIndex} value={choise.choise_sort}>
                          {choise.choise_text}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: "0 20px", fontWeight: "bold" }}>
                    {smallItem.setsumon_text2}
                  </td>
                </tr>
                </tbody>
              </table>
              </div>
            );
          } else if(smallItem.setsumon_type == 6) {
            const linkedChoises = choiseItems.filter(choiseItem => choiseItem.choise_type == smallItem.setsumon_type);
            rows.push(
              <div className="subtable-container">
              <table style={{ width: "90%", margin: "0 20px", borderCollapse: "collapse" }}>
                <tbody>
                <tr>
                  <td colSpan="2" style={{ fontWeight: "bold" }}>
                    {smallItem.setsumon_text.split('\\n').map((line, index) => (
                      <span key={index}>
                        {line}
                        <br />
                      </span>
                    ))}
                  </td>
                </tr>
                <tr key={`input-${smallItem.id}`}>
                  <td style={{ width: "85%", padding: "0 20px", textAlign: "right", fontWeight: "bold" }}>
                    {smallItem.setsumon_text2}
                  </td>
                  <td>
                    <select value={answerItems[smallItem.id] || ''} onChange={(e) => changed(['answerItems', smallItem.id], e.target.value)} style={{ maxWidth: '150px' }}>
                      <option value="">選択してください</option>
                      {linkedChoises.map((choise, choiceIndex) => (
                        <option key={choiceIndex} value={choise.choise_sort}>
                          {choise.choise_text}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
                </tbody>
              </table>
              </div>
            );
          } else if(smallItem.setsumon_type == 7) {
            rows.push(
              <div className="subtable-container">
              <table style={{ width: "30%", margin: "10px", border: "1px solid", borderCollapse: "collapse" }}>
                <tbody>
                <tr key={`input-${smallItem.id}`}>
                  <th style={{ width: "40%", backgroundColor: "#f1f1f1", textAlign: "center", border: "1px solid", fontWeight: "bold" }} key={`label-${key}`}>
                    {smallItem.setsumon_text}
                  </th>
                  <td>
                    <input type="text" value={answerItems[smallItem.id] || ''} onInput={(e) => (e.target.value = e.target.value.replace(/[^0-9]/g, ""))}
                      onChange={(e) => changed(['answerItems', smallItem.id], e.target.value)}
                      style={{ width: "80%", textAlign: "right", appearance: "textfield" }}
                    /> 円
                  </td>
                </tr>
                </tbody>
              </table>
              </div>
            );
          } else if(smallItem.setsumon_type == 8) {
            if(inputTitle != smallItem.setsumon_text) {
              inputText =  (
                <tr>
                  <td colSpan="3">{smallItem.setsumon_text}</td>
                </tr>
              );
            } else {
              inputText = null
            }
            rows.push(
              <div className="subtable-container">
              <table style={{ width: "100%", margin: "10px", borderCollapse: "collapse", fontWeight: "bold" }}>
                <tbody>
                {inputText}
                <tr key={`input-${smallItem.id}`}>
                  <th style={{ width: "30%", padding: "0 10px", textAlign: "left", fontWeight: "bold" }} key={`label-${key}`}>
                    {smallItem.setsumon_text2}
                  </th>
                  <td style={{ width: "20%" }}>
                    <input type="text" value={answerItems[smallItem.id] || ''} onChange={(e) => changed(['answerItems', smallItem.id], e.target.value)} onInput={(e) => (e.target.value = e.target.value.replace(/[^0-9]/g, ""))}
                      style={{ width: "50%", textAlign: "right", appearance: "textfield" }}
                    /> 件
                  </td>
                  <td style={{ width: "50%" }}></td>
                </tr>
                </tbody>
              </table>
              </div>
            );
            inputTitle = smallItem.setsumon_text
          } else if(smallItem.setsumon_type == 9) {
            const linkedChoises = choiseItems.filter(choiseItem => choiseItem.choise_type == smallItem.setsumon_type);
            rows.push(
              <div className="subtable-container">
              <table style={{ width: "90%", margin: "0 20px", borderCollapse: "collapse" }}>
                <tbody>
                <tr key={`input-${smallItem.id}`}>
                  <td style={{ width: "85%", fontWeight: "bold" }}>
                    {smallItem.setsumon_text}
                  </td>
                  <td>
                    <select value={answerItems[smallItem.id] || ''} onChange={(e) => changed(['answerItems', smallItem.id], e.target.value)} style={{ maxWidth: '150px' }}>
                      <option value="">選択してください</option>
                      {linkedChoises.map((choise, choiceIndex) => (
                        <option key={choiceIndex} value={choise.choise_sort}>
                          {choise.choise_text}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
                </tbody>
              </table>
              </div>
            );
          }
        });

        // 合計を表示するセルを追加
        if (summaryTableFlg) {
          rows.push(
            <table style={{ width: "100%", margin: "10px", border: "1px solid", borderCollapse: "collapse" }}>
              <tbody>
                <tr key={`smallItem-header-${mediumItem.id}`}>
                  <th style={{ width: "9px", backgroundColor: "#f1f1f1", border: "1px solid", fontWeight: "bold" }}>
                    項目
                  </th>
                  {choiceHeaders}
                  <th style={{ width: "7%", backgroundColor: "#f1f1f1", border: "1px solid", fontWeight: "bold" }}>
                    合計
                  </th>
                </tr>
                {Object.keys(choiceInputs2).map((key) => (
                  <tr key={`smallItem-input-${key}`}>
                    {choiceInputs2[key].inputs}
                    <td style={{ width: "7%", textAlign: "right", padding: "0 10px", border: "1px solid" }}>
                      {this.state.choiceInputs2[key] ? this.state.choiceInputs2[key].sum : 0}
                    </td>
                  </tr>
                ))}
                <tr key={`smallItem-summary-${mediumItem.id}`}>
                  <th style={{ width: "9px", backgroundColor: "#f1f1f1", border: "1px solid" }}>
                    各年代小計{summaryCnt}
                  </th>
                  {/* 全体の sumByIndex を計算する */}
                  {(() => {
                    const combinedSumByIndex = {};
                    const keyIndex = parseInt(mediumItem.id, 10);

                    Object.keys(choiceInputs2).forEach((key) => {
                      choiceInputs2[key].inputs.forEach((item, index) => {
                        if (parseInt(key, 10) === keyIndex) {
                          if (!combinedSumByIndex[keyIndex]) {
                            combinedSumByIndex[keyIndex] = {};
                          }
                          if (!combinedSumByIndex[keyIndex][index + 1]) {
                            combinedSumByIndex[keyIndex][index + 1] = 0;
                            if(this.state.choiceInputs2[key]) {
                              if(this.state.choiceInputs2[key].sumByIndex[index + 1]) {
                                combinedSumByIndex[keyIndex][index + 1] = this.state.choiceInputs2[key].sumByIndex[index + 1];
                              }
                            }
                          }
                        }
                      });
                      // combinedSumByIndex[keyIndex] の最後のインデックスの値を totalsum に設定
                      if (combinedSumByIndex[keyIndex]) {
                        const indices = Object.keys(combinedSumByIndex[keyIndex])
                          .map((index) => parseInt(index, 10))
                          .sort((a, b) => a - b); // インデックスを数値順にソート

                        if (indices.length > 0) {
                          const lastIndex = indices[indices.length - 1]; // 最後のインデックスを取得
                          // totalsum を combinedSumByIndex に設定
                          if(this.state.choiceInputs2[key]) {
                            combinedSumByIndex[keyIndex][lastIndex] = this.state.choiceInputs2[key] ? this.state.choiceInputs2[key].totalsum : 0;
                          }
                        }
                      }
                    });

                    // combinedSumByIndex[keyIndex] の内容を <td> に変換して返す
                    if (combinedSumByIndex[keyIndex]) {
                      return Object.keys(combinedSumByIndex[keyIndex])
                        .sort((a, b) => parseInt(a, 10) - parseInt(b, 10)) // インデックスを数値で昇順ソート
                        .map((index) => (
                          <td key={index} style={{ width: "7%", textAlign: "right", padding: "0 10px", border: "1px solid" }}>
                            {combinedSumByIndex[keyIndex][index]}
                          </td>
                        ));
                    }

                    return null; // combinedSumByIndex[keyIndex] が存在しない場合は何も返さない
                  })()}
                </tr>
              </tbody>
            </table>
          );
        }

        if(mediumItem.setsumon_comment) {
          rows.push(
            <tr key={`mediumComment-${mediumItem.id}`}>
              <td colSpan="17" style={{ paddingLeft: "20px" }}>
                {mediumItem.setsumon_comment.split('\\n').map((line, index) => (
                  <span key={index}>
                    {line}
                    <br />
                  </span>
                ))}
              </td>
            </tr>
          );
        }

        summaryCnt++
      });

      return rows;
    };

    return (
      <fieldset>
        <legend>{survey.surveyMainItems.year}年度 {survey.surveyMainItems.title}</legend>
        <div className="text-right">一般社団法人日本型枠工事業協会（略称：日本型枠）</div>
        <br />

        {/* タイプ1のテーブル */}
        <table style={{ width: '90%', margin: '0 auto', borderCollapse: 'collapse' }}>
          <tbody>
            {bigQuestionItems
              .filter((bigItem) => bigItem.setsumon_type == 1)
              .map((bigItem, index) => renderTable1(bigItem))}
          </tbody>
        </table>

        <br />

        {/* タイプ2のテーブル */}
        <table style={{ width: '90%', margin: '0 auto', borderCollapse: 'collapse' }}>
          <tbody>
            {bigQuestionItems
              .filter((bigItem) => bigItem.setsumon_type == 2)
              .map((bigItem, index) => renderTable2(bigItem))}
          </tbody>
        </table>
      </fieldset>
    );
  }
  onFormButtonClicked (name, e) {
    e.preventDefault()
    const id = this.state.id
    switch (name) {
      case 'save':
        this.saveServey()
        break
      case 'cancel':
        this.props.history.push('/company_admin/')
        break
      default:
        break
    }
  }
  render () {
    if (!this.state.isLoaded) {
      return <Loading />;
    }

    // surveyQuestionDataが無い場合
    if (!this.state.surveyMainItems || !Object.keys(this.state.surveyMainItems).length) {
      return (
        <div>
          <section className='nav-page'>
            <div className='container'>
              <div className='row'>
                <div className='span7'>
                  <header className='page-header'>
                    <h3>アンケート回答<br /><small>こちらでアンケートの回答をできます。</small></h3>
                  </header>
                </div>
                <div className='span9'>
                  <ul className='nav nav-pills'>
                    <li className='kw-btn-area'>
                      <button rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back')}>
                        <i className='icon-arrow-left icon-large' />
                        <span>戻る</span>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
          <section className='page container'>
            <div className='container'>
              <div className='kw-ic-info-regist-area span16' style={{ marginBottom: '150px' }}>
                <p>現在、回答可能なアンケートはありません。</p>
              </div>
            </div>
          </section>
        </div>
      );
    }

    let buttonLayout = null;
    if (this.state.surveyMainItems.shimeFlg) {
      buttonLayout = (
        <footer className='form-actions' id='submit-actions'>
          <div className='kw-ic-info-regist-area' style={{ fontWeight: "bold" }}>
            <p>アンケートは締め切りました。</p>
          </div>
          <button disabled className='btn btn-gray' onClick={(e) => this.onFormButtonClicked('save', e)}>
            保存
          </button>
          <button className='btn btn-default' onClick={(e) => this.onFormButtonClicked('cancel', e)}>
            キャンセル
          </button>
        </footer>
      );
    } else {
      buttonLayout = (
        <footer className='form-actions' id='submit-actions'>
          <button className='btn btn-primary' onClick={(e) => this.onFormButtonClicked('save', e)}>
            保存
          </button>
          <button className='btn btn-default' onClick={(e) => this.onFormButtonClicked('cancel', e)}>
            キャンセル
          </button>
        </footer>
      );
    }

    let summaryCnt = 1;
    const surveyDetail = this.renderSurveyDetail(this.state, summaryCnt);

    return (
      <div>
        <section className='nav-page'>
          <div className='container'>
            <div className='row'>
              <div className='span7'>
                <header className='page-header'>
                  <h3>アンケート回答<br /><small>こちらでアンケートの回答をできます。</small></h3>
                </header>
              </div>
              <div className='span9'>
                <ul className='nav nav-pills'>
                  <li className='kw-btn-area'>
                    <button rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back')}>
                      <i className='icon-arrow-left icon-large' />
                      <span>戻る</span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className='page container'>
          <form className='form-horizontal' method='post' onKeyDown={(e) => {if (e.key === 'Enter') {e.preventDefault();}}}>
            <div className='container'>
              <div className='kw-ic-info-regist-area span16'>
                {surveyDetail}
                {buttonLayout}
              </div>
            </div>
          </form>
        </section>
      </div>
    );
  }
}

export default SurveyAnswer



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/SurveyAnswer.js